export const AXIS_DEBIT_EMI_ISSUER = 239;
export const ICICI_DEBIT_EMI_ISSUER = 234;
export const HDFC_DEBIT_EMI_ISSUER = 233;
export const KOTAK_DEBIT_EMI_ISSUER = 237;
export const HDFC_CREDIT_EMI_ISSUER = 3;
export const FEDERAL_DEBIT_EMI_ISSUER = 243;

export const ISSUER_DEBIT_EMI = [AXIS_DEBIT_EMI_ISSUER, ICICI_DEBIT_EMI_ISSUER, HDFC_DEBIT_EMI_ISSUER,
    KOTAK_DEBIT_EMI_ISSUER, FEDERAL_DEBIT_EMI_ISSUER];

export const ISSUER_DEBIT_EMI_OTP_TO_BE_SHOWN = [HDFC_DEBIT_EMI_ISSUER, KOTAK_DEBIT_EMI_ISSUER, FEDERAL_DEBIT_EMI_ISSUER];


